import type {
    BusinessOrderDetails,
    Order,
    OrderModel,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'orders/kiosk';

export function getOrders(query: BusinessOrderDetails.SearchQuery) {
    return api.get<BusinessOrderDetails.SearchResponse>(`${rootPath}`, query);
}

export function getOrder(id: number) {
    return api.get<BusinessOrderDetails.DetailsResponse>(`${rootPath}/${id}`);
}

export function updateOrder(id: number, data: Order.UpdateRequest) {
    return api.put<OrderModel>(`${rootPath}/${id}`, data);
}
export function uploadOrderImage(
    data: BusinessOrderDetails.UploadImageRequest
) {
    return api.post<BusinessOrderDetails.UploadImageResponse>(
        `${rootPath}/image`,
        data
    );
}

export function reviewPickupFaceVerification(
    id: number,
    data: Order.KioskPickupFaceReviewRequest
) {
    return api.post<OrderModel>(`${rootPath}/${id}/pickup-face-review`, data);
}

export function adjustStartedOrder(
    id: number,
    data: Order.KioskAdjustStartedOrderRequest
) {
    return api.post<Order.KioskAdjustStartedOrderResponse>(
        `${rootPath}/${id}/adjust`,
        data
    );
}
